import { service } from "node-back-client/src/services/api";

class UserService {
  apiService;

  constructor(url) {
    this.apiService = service(`${url}Controllers`, "Profile");
  }

  async getProfiles(filter, skip, limit) {
    let profiles = await this.apiService.post("", {
      filter,
      skip,
      limit,
    });
    let cheaterTypes = [
      "N/A",
      "Speed Hack",
      "Spammer",
      "Memory",
      "Manual",
      "Time",
    ];
    profiles.data.forEach((x) => (x.cheaterType = cheaterTypes[x.cheaterType]));
    profiles.data.forEach((x) => {
      if (x.social_media) {
        if ("undefined" in x.social_media) {
          console.log(x.social_media)
          delete x.social_media["undefined"]
        }
      }
    });
    profiles.data.forEach((x) => (x.binded = (x.social_media) ? Object.keys(x?.social_media).length > 0 ? '✅' : '❌' : '❌'));
    return profiles;
  }

  async getProfilesByCharId(serverid, id) {
    try {
      let profile = await this.apiService.get(
        "Server/" + serverid + "/Characters/" + id
      );
      let cheaterTypes = [
        "N/A",
        "Speed Hack",
        "Spammer",
        "Memory",
        "Manual",
        "Time",
      ];
      profile.cheaterType = cheaterTypes[profile.cheaterType];
      profile.binded = (profile.social_media) ? Object.keys(profile?.social_media).length > 0 ? '✅' : '❌' : '❌';
      return profile;
    } catch (error) {
      return [];
    }
  }
}

export const userService = UserService;
